import React from "../_snowpack/pkg/react.js";
import cs from "../_snowpack/pkg/classnames.js";
import "./Card.css";
export default function Card({className, type, children: content, ...pass}) {
  return /* @__PURE__ */ React.createElement("div", {
    className: cs("card-component", type && `card-component--${type}`, className),
    ...pass
  }, content);
}
